import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["rowNumbers", "controlled"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useTheme } from "@emotion/react";
import React, { useRef } from "react";
import { TABLE_ROW_NUMBER_CLASS } from "../../themes/common/classes";
import { ROW_NUMBER_COLUMN_KEY } from "../constants";
import extractTheme from "./extractTheme";
/**
 * This is the actual HOC that we export. It returns a Table component
 * with row numbers.
 * @type {Component}
 */

import { jsx as _jsx } from "@emotion/react/jsx-runtime";

function withRowNumbers(TableComponent) {
  const WrappedTable = /*#__PURE__*/React.forwardRef((props, ref) => {
    const {
      rowNumbers,
      controlled
    } = props,
          others = _objectWithoutProperties(props, _excluded); // eslint-disable-line no-unused-vars


    const internalRef = useRef();
    const tableNodeRef = ref || internalRef;
    const theme = useTheme();
    const {
      cssRowNumbers
    } = extractTheme({
      theme
    });

    if (rowNumbers) {
      const {
        columns: originalColumns
      } = others;
      const offset = rowNumbers.offset || 1;
      const columns = [{
        key: ROW_NUMBER_COLUMN_KEY,
        className: TABLE_ROW_NUMBER_CLASS,
        header: _jsx("span", {
          className: "wf-u-visually-hidden",
          children: "Row "
        }),
        formatter: _ref => {
          let {
            itemIndex
          } = _ref;
          return itemIndex + offset;
        }
      }, ...originalColumns];
      return _jsx(TableComponent, _objectSpread(_objectSpread({}, others), {}, {
        columns: columns,
        ref: tableNodeRef,
        css: cssRowNumbers
      }));
    } else {
      return _jsx(TableComponent, _objectSpread(_objectSpread({}, others), {}, {
        ref: tableNodeRef
      }));
    }
  });
  WrappedTable.displayName = `withRowNumbers(${TableComponent.displayName || TableComponent.name})`;
  return WrappedTable;
}

export default withRowNumbers;